import styled from 'styled-components';

import { COLORS } from '@r1-frontend/ui-react/assets/js/constants';
import { BaseButton } from '@r1-frontend/ui-react/components/buttons/baseButton';
import InputSimple, { phoneDecorator } from '@r1-frontend/ui-react/components/inputSimple';
import { FlexBoxRow } from '@r1-frontend/ui-react/components/layouts/flexBoxGrid';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

import { breakPoints } from '~/src/features/domru-bonus/styled';

const inputPhone = phoneDecorator(InputSimple);

const ICON_SIZE = '58px';
const ICON_SIZE_MOBILE = '65px';

export const InfoBlock = styled.div`
    display: flex;
    margin-bottom: 45px;
    align-items: center;

    @media (max-width: ${breakPoints.mobile}) {
        flex-direction: column;
        margin-bottom: 33px;
        align-items: flex-start;
    }
`;

export const IconBlock = styled.div`
    min-width: ${ICON_SIZE};
    height: ${ICON_SIZE};
    margin-right: 19px;
    background: url('/static/images/icons/bonus-rings.svg') 0 0 / cover no-repeat;

    @media (max-width: ${breakPoints.mobile}) {
        min-width: ${ICON_SIZE_MOBILE};
        height: ${ICON_SIZE_MOBILE};
        margin-right: 0;
        margin-bottom: 19px;
    }
`;

export const FormText = styled.div`
    ${FONTS.S};
    white-space: pre-wrap;
`;

export const FormRow = styled(FlexBoxRow)`
    max-width: 84.75%;
    display: flex;
    align-items: flex-start;

    @media (max-width: ${breakPoints.sDesktop}) {
        justify-content: space-between;
        max-width: unset;
        width: 100%;
    }

    @media (max-width: ${breakPoints.laptop}) {
        max-width: 500px;
    }
`;

export const PhoneInput = styled(inputPhone)``;

export const Button = styled(BaseButton)`
    margin: 0 auto 20px 0;
    max-width: 220px;

    @media (max-width: ${breakPoints.laptop}) {
        max-width: unset;
        width: 230px;
    }
`;

export const FormPolicy = styled.p`
    ${FONTS.XS};
    color: ${COLORS.middleGray};
    margin-bottom: 20px;
    white-space: pre-wrap;
`;

export const PolicyLink = styled.a`
    color: ${COLORS.middleGray};
    ${FONTS.MediumXS};
    text-decoration: underline;
`;
